import "./xpressOrders.css";
import moment from "moment";

const XpressOrders = ({
  xpressOrders,
  setIsPopupVisible,
  setOrder,
  setStatus,
}) => {
  const handleRowClick = (order, orderStatus) => {
    setOrder(order);
    setIsPopupVisible(true);
    setStatus(orderStatus);
  };

  const statusStyles = {
    ACCEPTED: "badge bg-primary",
    "OUT FOR DELIVERY": "badge bg-warning text-dark",
    DELIVERED: "badge bg-success",
    REJECTED: "badge bg-danger",
  };

  // Number of empty rows to fill the table
  const rowsPerPage = 10; // Adjust as needed
  const emptyRows = Array.from(
    { length: Math.max(0, rowsPerPage - xpressOrders.length) },
    (_, index) => index
  );

  return (
    <div className="mt-4 xpressOrders">
      <table className="table table-bordered table-hover">
        <thead className="headingTable">
          <tr>
            <th className="text-center fs-6">Order ID</th>
            <th className="text-center fs-6">Time</th>
            <th className="text-center fs-6">Items</th>
            <th className="text-center fs-6">Phone Number</th>
            <th className="text-center fs-6">Status</th>
            <th className="text-center fs-6">Delivery By</th>
          </tr>
        </thead>
        <tbody className="tableData">
          {xpressOrders?.map((order) => {
            const orderStatus =
              order.status.toUpperCase() === "READY TO PICK" ||
              order.status.toUpperCase() === "ACCEPTED"
                ? order.deliveryDetails !== "N/A"
                  ? "OUT FOR DELIVERY"
                  : "ACCEPTED"
                : order.status;

            const [startTime, endTime] = order.deliverBy
              .split(" - ")
              .map((time) => time.trim().split(" ")[0] + " " + time.split(" ")[1]);

            const startMoment = moment(startTime, "hh:mm A");
            const endMoment = moment(endTime, "hh:mm A");

            const difference = endMoment.diff(startMoment, "minutes");
            const formattedDate = moment(order.deliveryDate).format("dddd, Do MMM");

            return (
              <tr
                className="rowOrderData"
                key={order.orderID}
                onClick={() => handleRowClick(order, orderStatus)}
              >
                <td className="text-center fs-6">
                  {order.orderID.slice(0, -4)}
                  <strong>{order.orderID.slice(-4)}</strong>{`\n`}
                  <h6>{order.orderType}</h6>
                </td>
                <td className="text-center fs-6">
                  {order.orderTimeStamp.substring(11, 16)}
                </td>
                <td className="fs-6">
                  {order.orderedItems.map((item, index) => (
                    <div key={index}>
                      {item.quantity} - {item.menuName}{`\n`}<strong>{item?.itemType}</strong>
                    </div>
                  ))}
                </td>
                <td className="text-center fs-6">
                  {order.craverDetails.craverMobile}
                </td>
                <td className="text-center fs-6">
                  <span
                    className={`badge ${statusStyles[orderStatus]} px-3 py-2`}
                  >
                    {orderStatus}
                  </span>
                </td>
                {difference === 60 ? (
                  <td className="text-center  small">
                    <p>{order.deliverBy}</p>
                   <p>
                   {formattedDate}</p>
                 </td>
                ) : (
                  <td></td>
                )}
              </tr>
            );
          })}
          {emptyRows.map((_, index) => (
            <tr key={`empty-${index}`} style={{ height: "3rem" }}>
              <td colSpan={6}></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default XpressOrders;
